export default __webpack_public_path__ + "static/media/bg-nav-rest-and-rejuvenate.609e6406.jpg";